export default function() {
  return this.locations.filter(location => {
    return location.active;
  });
}
